/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type { GetRiotDdragonChampionsQueryResponse } from "../types/GetRiotDdragonChampions.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getRiotDdragonChampionsQueryKey = () =>
  [{ url: "/riot/ddragon/champions" }] as const;

export type GetRiotDdragonChampionsQueryKey = ReturnType<
  typeof getRiotDdragonChampionsQueryKey
>;

/**
 * @summary Список чемпионов патча. Нужен превью карточки в админке, чтобы можно было
 * подставить любого чемпиона, а не только тех, что зашиты в сценарии.
 * {@link /riot/ddragon/champions}
 */
export async function getRiotDdragonChampions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetRiotDdragonChampionsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/riot/ddragon/champions`, ...requestConfig });
  return res;
}

export function getRiotDdragonChampionsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getRiotDdragonChampionsQueryKey();
  return queryOptions<
    ResponseConfig<GetRiotDdragonChampionsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetRiotDdragonChampionsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getRiotDdragonChampions({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Список чемпионов патча. Нужен превью карточки в админке, чтобы можно было
 * подставить любого чемпиона, а не только тех, что зашиты в сценарии.
 * {@link /riot/ddragon/champions}
 */
export function useGetRiotDdragonChampions<
  TData = ResponseConfig<GetRiotDdragonChampionsQueryResponse>,
  TQueryData = ResponseConfig<GetRiotDdragonChampionsQueryResponse>,
  TQueryKey extends QueryKey = GetRiotDdragonChampionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetRiotDdragonChampionsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getRiotDdragonChampionsQueryKey();

  const query = useQuery(
    {
      ...getRiotDdragonChampionsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
